import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SuperBatmanHeaderFactoryService {

  constructor() { }


  createHeader() {
    return {
      KeynetixCloud: "U3VwZXJCYXRtYW5GYXN0",
    };
  }
}
